const queueTails = new Map<string, Promise<void>>();

const sheetLayoutQueueKey = (
  businessId: string,
  runId: string,
  sheetId: string,
) => `${businessId}:${runId}:${sheetId}`;

export const enqueueSheetLayoutMutation = <Result>({
  businessId,
  runId,
  sheetId,
  execute,
}: {
  businessId: string;
  runId: string;
  sheetId: string;
  execute: () => Promise<Result>;
}): Promise<Result> => {
  const key = sheetLayoutQueueKey(businessId, runId, sheetId);
  const execution = (queueTails.get(key) ?? Promise.resolve()).then(execute);
  const tail = execution.then(
    () => undefined,
    () => undefined,
  );

  queueTails.set(key, tail);
  void tail.then(() => {
    if (queueTails.get(key) === tail) queueTails.delete(key);
  });

  return execution;
};
